import React,{useState, useEffect} from 'react';
import {doGet, doPatch, doDownloadPengajuanExcel, doDownloadPdf} from 'utils/apiUtil.js'
import {endpoint} from 'utils/constants.js'
import { Redirect,useRouteMatch, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import Search from '@material-ui/icons/Search';

import ArrowBack from '@material-ui/icons/ArrowBack';
import Paper from '@material-ui/core/Paper';
import DebouncedTextField from 'components/DebouncedTextField.js';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { format, parse, isAfter } from 'date-fns'
import Select from 'react-select'
import {selectCustomZindex} from 'utils/theme'
import numeral from 'numeral'
import TablePagination   from '@material-ui/core/TablePagination';
import { generalListOptionMapper } from 'utils/mappers.js';


const PembelianBuku =(props)=> {

  let { path, url } = useRouteMatch();
  let history = useHistory();
  const classes = useStyles();
  const user = useSelector(state => state.user);
  const [orders, setorders] = useState([]);
  const [selectedOrder, setselectedOrder] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(10)
  const [page, setPage] = useState(1)
  const [totalRows, setTotalRows] = useState(0)
  
  const [statusOptions, setstatusOptions] = useState([
    {label:'Packed', value:8},
    {label:'Printed', value:7},
    {label:'Returned', value:6},
    {label:'Delivered', value:9},
    {label:'Cancel', value:3},
    {label:'Paid', value:2},
    {label:'Unpaid', value:1}
  ]);

  const [paymentTypeOptions, setpaymentTypeOptions] = useState([
    {label:'Manual', value:1},
    {label:'Transfer', value:2} 
  ]);

  const [sortOptions, setsortOptions] = useState([
    {label:'Harga Tertiggi', value:"total_pay-DESC"},
    {label:'Harga Terendah', value:"total_pay-ASC"},
    {label:'Pengambilan Terbaru', value:"pickup_date-DESC"},
    {label:'Pengambilan Terlama', value:"pickup_date-ASC"},
    {label:'Nama Pelanggan', value:"customer-ASC"}
  ]);

  const [locationOptions, setlocationOptions] = useState([])

  const [filters, setfilters] = useState({
    status:null,
    keyword:""
  });
  const [openDialog, setopenDialog] = React.useState(false);
  const [dialogWidth, setdialogWidth] = useState('sm');
  const [dialogContent, setdialogContent] = useState(null);
  const [dialogTitle, setdialogTitle] = useState('title');
 
  const getDefaultHeader =()=>{
    return {"Authorization":`Bearer ${user.token}`}
  }

  const changePage=(event, newPage)=>{
    setPage(newPage+1)
  }

  const changeRowsPerPage = (event)=> {
      setRowsPerPage(+event.target.value);
      setPage(1);
  }

  
  const back =()=>{
    history.goBack()
  }

  const getlocationOptions =async()=>{
    const params={}
        
    const response = await doGet(endpoint.location, params, getDefaultHeader());        
    if(!response.error){
      const locations = response.data      
      setlocationOptions(generalListOptionMapper(locations))
    }
  }


  const getorders =async()=>{
    const params={
      keyword : filters.keyword.trim()!==""?filters.keyword : null,
      sort:filters.sort?filters.sort.value:null,
      page:page,
      limit:rowsPerPage
    }
        
    const response = await doGet(endpoint.pengajuan_pembelian, params, getDefaultHeader());        
    if(response && response.data && response.data.data){
      const orders = response.data.data      
      setorders(orders)
      setPage(response.data.current_page)
      setTotalRows(response.data.total)
    }    
    
  }  

  const exportorders =async()=>{
    const params={
      keyword : filters.keyword.trim()!==""?filters.keyword : null,
      sort:filters.sort?filters.sort.value:null
    }
        
    
    const response = await doDownloadPengajuanExcel(endpoint.pengajuan_pembelian_export, params, getDefaultHeader());        
    
    
    
    
  }  

  const showDetail =(order)=>{
    setselectedOrder(order)    
  }

    

  const getStatus = (order)=>{
    const expired  = isAfter(new Date(), order.expired)
    if(expired && order.statusName==="unpaid" && order.paymentType==="2"){
      return "expired"
    }else{
      return order.statusName
    }
  }  

  const getPaymentType = (order)=>{
    if(order.paymentType==="1"){
      return "manual"
    }else{
      return "transfer"
    }
  }

  const closeDialog =()=>{    
    setopenDialog(false)
    setselectedOrder(null)
  }  
  
  const filtersChange =(fieldName, event)=>{    
    let newFilters = {...filters}
    let value = event

    newFilters[fieldName] = value    
    setfilters(newFilters)
  }

  const packing =async(order)=>{    
    const payload = {
      id:order.id
    }
    const response = await doPatch(endpoint.admin_order_pack, payload,"pack order",getDefaultHeader())
    
    if(response && !response.error){
      getorders()
    }
  }

  const toPaid =async(order)=>{    
    const payload = {
      id:order.id
    }
    const response = await doPatch(endpoint.order_to_paid, payload, "paid order", getDefaultHeader())
    
    if(response && !response.error){
      getorders()
    }
  }

  const printInvoice=async(order)=>{
    const params={}        
    await doDownloadPdf(endpoint.admin_order_id_invoice.replace("id",order.id), params, getDefaultHeader());            
    getorders()
  }


  const Action =({order, printInvoice, packing})=>{    
    if(order){
      if(
        (!order.printBy) && 
        (order.statusCode==="2" || (order.statusCode==="1" && order.paymentType==="1"))
        ){
        return(
          <Button onClick={()=>printInvoice(order)} color="primary">
            Print
          </Button>
        ) 
      }
      else 
      if(order.statusCode==="7"){
        return(
          <>
            <Button onClick={()=>packing(order)} color="primary">
              Pack
            </Button>

            <Button variant="contained" size="small"   onClick={()=>toPaid(order)} color="primary" style={{margin:'0 8px'}}>
                  to paid
                </Button>
            
           </>
        ) 
      }
      else
      {
        return null
      }      
    }else{
      return null
    }
  }  
  
   
  useEffect(() => {
    getlocationOptions()
  }, []) 

  useEffect(() => {
    getorders()
  }, [page,rowsPerPage])  


  useEffect(() => {
    getorders()
  }, [filters.keyword])
  

  if(user && user.token){
    return (
      <React.Fragment>
        <CssBaseline/>
        <Grid container alignItems='flex-start' alignContent="flex-start"  className={classes.root}>
            <Grid item xs={1}>              
                <IconButton color="primary" aria-label="go back" component="span" onClick={back}>
                  <ArrowBack />
                </IconButton>              
            </Grid>
            <Grid container item xs={11} justify="flex-end" alignItems="center" >                                                    
                
            </Grid>          
            
            <Paper elevation={1} style={{width:'100%', margin:'4px 0', padding:8}}>
                <Grid container spacing={1} alignItems="center" >                                                    
                    <Grid item xs={6} md={3} >
                      <DebouncedTextField
                          margin="dense"
                          id="keyword"
                          placeholder="order number"                                                                                   
                          fullWidth
                          variant="outlined"
                          value={filters.keyword}
                          onChange={(e)=>{filtersChange('keyword',e)}}
                      />
                    </Grid>

                    

                      {orders && orders.length > 0 && (
                     <Grid item xs={3} >
                      <Button variant="contained" size="small" onClick={exportorders} color="primary" style={{margin:'0 8px'}}>
                        Export Excell
                      </Button>
                     </Grid>    
                    )}      
                    
                </Grid>
                                     
            </Paper>
            
            
                <Grid container justify="center" style={{margin:'4px 0'}}>                                           
                    <TableContainer component={Paper}>
                        <Table className={classes.table} aria-label="simple table">
                            <TableHead>
                                <TableRow className={classes.rowHead}>
                                    <TableCell align="left" className={classes.cellHead}>No&nbsp;Dokumen&nbsp;Pengajuan</TableCell>
                                    <TableCell align="left" className={classes.cellHead}>No&nbsp;Dokumen&nbsp;Evaluasi</TableCell>
                                    <TableCell align="left" className={classes.cellHead}>Tahun&nbsp;Ajaran</TableCell>
                                    <TableCell align="left" className={classes.cellHead}>Jenjang</TableCell>
                                    <TableCell align="left" className={classes.cellHead}>Mata&nbsp;Pelajaran</TableCell>
                                    <TableCell align="left" className={classes.cellHead}>Judul&nbsp;Buku</TableCell>
                                    <TableCell align="left" className={classes.cellHead}>Tahun&nbsp;Penerbit</TableCell>
                                    <TableCell align="left" className={classes.cellHead}>Pengarang</TableCell>
                                    <TableCell align="left" className={classes.cellHead}>Penerbit</TableCell>
                                    <TableCell align="left" className={classes.cellHead}>Sinopsis</TableCell>
                                    <TableCell align="right" className={classes.cellHead}>jumlah</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                            {orders.map((order) => (
                                <TableRow key={order.id}>
                                    <TableCell align="left" onClick={()=>showDetail(order)} className={classes.clickable}>{order?.no_dokumen_pengajuan_pembelian}</TableCell>
                                    <TableCell align="left">{order?.no_dokumen_evaluasi}</TableCell>
                                    <TableCell align="left">{order?.tahun_ajaran}</TableCell>
                                    <TableCell align="left">{order?.jenjang}</TableCell>
                                    <TableCell align="left">{order?.mata_pelajaran} </TableCell>
                                    <TableCell align="left">{order?.judul_buku} </TableCell>
                                    <TableCell align="left">{order?.tahun_terbit} </TableCell>
                                    <TableCell align="left">{order?.pengarang} </TableCell>
                                    <TableCell align="left">{order?.penerbit} </TableCell>
                                    <TableCell align="left">{order?.sinopsis} </TableCell>
                                    <TableCell align="right">{order?.jumlah} </TableCell>
                                </TableRow>
                            ))}
                            </TableBody>
                        </Table>
                        <Grid container justify="flex-end" className={classes.paginationContainer}>
                          <TablePagination
                              rowsPerPageOptions={[10, 25, 50]}
                              component="div"
                              count={totalRows}
                              rowsPerPage={rowsPerPage}
                              page={page-1}
                              backIconButtonProps={{
                                  'aria-label': 'previous page',
                              }}
                              nextIconButtonProps={{
                                  'aria-label': 'next page',
                              }}
                              onChangePage={changePage}
                              onChangeRowsPerPage={changeRowsPerPage}
                          />
                        </Grid>
                    </TableContainer>
                </Grid>            
            
            
        </Grid>

        <Dialog
        fullWidth={true}
        maxWidth={dialogWidth}
        open={openDialog}
        onClose={closeDialog}
        aria-labelledby="max-width-dialog-title"
        >
            <DialogTitle id="max-width-dialog-title">{dialogTitle}</DialogTitle>
            <DialogContent>
                {dialogContent}
            </DialogContent>
        </Dialog>
      </React.Fragment>
    );
  }
  else{
    return <Redirect to={{ pathname: '/login' }} />
  }

}

const useStyles = makeStyles((theme) => ({
    marginTop16:{
      marginTop:16  
    },  
    marginH4:{
      marginLeft:4,
      marginRight:4,
    },  
    root: {
      padding: theme.spacing(1)
    },
    rowHead:{
      backgroundColor:'#d5ecff'
    },
    cellHead:{
      color:'#2532d4',
      fontWeight:'bold'
    },
    clickable:{
      color:theme.palette.primary.main,
      fontWeight:'bold',
      cursor:'pointer'
    }
    
    
  }));


export default PembelianBuku;
